<template>
  <div>
    <Scroll>
        <Card>
          <p slot="title">物料大类</p>
          <div
            v-for="item of MaterialCategorylist"
            :key="item.ClassificationID"
            :class="item.ClassificationID === MaterialCategoryinfo1.ClassificationID?'ActiveMaterialCategory':'MaterialCategory'"
            @click="MaterialCategorySelectHandleClick(item)"
          >
            <List>
              <ListItem>
                <ListItemMeta
                  :avatar="item.IconUrl"
                  title="大类名称"
                  :description="item.Classification"
                />
                <ListItemMeta title="单位" :description="item.unit" />
              </ListItem>
            </List>
          </div>
        </Card>
    </Scroll>
  </div>
</template>

<script>
export default {
  name: 'MaterialCategorylist',
  props: {
    MaterialCategorylist: Array,
    MaterialCategoryinfo: Array
  },
  computed: {
    MaterialCategoryinfo1: {
      get: function () {
        return this.MaterialCategoryinfo
      },
      set: function (value) {
        this.$emit('MaterialCategorySelectHandleClick', value)
      }
    }
  },
  methods: {
    MaterialCategorySelectHandleClick (item) {
      this.MaterialCategoryinfo1 = item
    }
  }
}
</script>
<style lang="scss" scoped>
.ActiveMaterialCategory ::v-deep .ivu-list-item-meta-title {
  color: #288cf0;
}
.ActiveMaterialCategory ::v-deep .ivu-list-item-meta-description {
  color: #288cf0;
}
.MaterialCategory {
  &:hover {
    background: #f3f3f3;
    cursor: pointer;
  }
}
.ActiveMaterialCategory {
  background: #f0faff;
  color: #288cf0;
  &:hover {
    cursor: pointer;
  }
}
</style>
